<template>
  <UButton
    :ui="mobileFullWidthButton"
    color="neutral"
    variant="subtle"
    size="lg"
    :trailing="true"
    :to="link"
    external
    :label="buttonText"
    icon="i-heroicons-arrow-top-right-on-square"
    @click.prevent="onClick"
  />
</template>
<script setup lang="ts">
import { mobileFullWidthButton } from '~~/modules/design-system/utils/nuxt-ui-config/components/button'

export interface propsInterface {
  buttonText: string
  link: string
}

const props = defineProps<propsInterface>()
const emit = defineEmits(['button-click'])

const onClick = () => {
  emit('button-click')
  setTimeout(() => window.location.assign(props.link), 10)
}
</script>
